import React, { useState, useEffect } from 'react';
import CustomSelect from '../customSelect/customSelect';
import OrganisationServices from "../../../services/organisation"
import { useNavigate } from 'react-router-dom';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';
import Select from 'react-select';
import CustomToast from '../../Toast';

const CreateOrgnisation = () => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [org_name, setOrgName] = useState('');
    const [org_size, setOrgSize] = useState('');
    const [org_sector, setOrgSector] = useState('');
    const [org_url, setOrgUrl] = useState('');
    const [org_address, setOrgAddress] = useState('');
    const [org_city, setOrgCity] = useState('');
    const [org_state, setOrgState] = useState('');
    const [org_pincode, setOrgPincode] = useState('');
    const [contact_name, setContactName] = useState('');
    const [contact_email, setContactEmail] = useState('');
    const [contact_mobile, setContactMobile] = useState('');
    const [contact_designation, setContactDesignation] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [contract_start_date, setContactStartDate] = useState('');
    const [contract_end_date, setContactEndDate] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [selectedOrgSize, setSelectedOrgSize] = useState('');
    const [selectedSector, setSelectedSector] = useState('');
    const [photo, setPhoto] = useState('');
    const [selectedFile, setSelectedFile] = useState();
    const [selectedCertificateFile, setSelectedCertificateFile] = useState();
    const [file, setFile] = useState();
    const [certificateFile, setCertificateFile] = useState();
    const [loader, setLoader] = useState(false)
    const navigate = useNavigate();
    const [entityInput, setEntityInput] = useState('');
    const [entities, setEntities] = useState([]);
    const [branchInput, setBranchInput] = useState('');
    const [branches, setBranches] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [selectedShowCity, setSelectedShowCity] = useState('');
    const [isFetchingCities, setIsFetchingCities] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [plansList, setPlansList] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState('');
    const [selectedShowPlan, setSelectedShowPlan] = useState('');
    const [isFetchingPlans, setIsFetchingPlans] = useState(false);
    const [step, setStep] = useState(1);

    const orgSizeOptions = [
        { value: '0 - 10', label: '0 - 10' },
        { value: '11 - 100', label: '11 - 100' },
        { value: '101 - 500', label: '101 - 500' },
        { value: '501 - 1000', label: '501 - 1000' },
        { value: '1000+', label: '1000+' },
    ];

    const sectorOptions = [
        { value: 'Agriculture', label: 'Agriculture' },
        { value: 'Automotive', label: 'Automotive' },
        { value: 'Banking', label: 'Banking' },
        { value: 'Biotechnology', label: 'Biotechnology' },
        { value: 'Chemicals', label: 'Chemicals' },
        { value: 'Construction', label: 'Construction' },

        { value: 'Consulting', label: 'Consulting' },
        { value: 'Consumer Goods', label: 'Consumer Goods' },
        { value: 'Education', label: 'Education' },
        { value: 'Energy', label: 'Energy' },
        { value: 'Engineering', label: 'Engineering' },
        { value: 'Entertainment', label: 'Entertainment' },

        { value: 'Environmental', label: 'Environmental' },
        { value: 'Fashion', label: 'Fashion' },
        { value: 'Finance', label: 'Finance' },
        { value: 'Food & Beverage', label: 'Food & Beverage' },
        { value: 'Government', label: 'Government' },
        { value: 'Healthcare', label: 'Healthcare' },

        { value: 'Hospitality', label: 'Hospitality' },
        { value: 'Information Technology (IT)', label: 'Information Technology (IT)' },
        { value: 'Insurance', label: 'Insurance' },
        { value: 'Legal', label: 'Legal' },
        { value: 'Manufacturing', label: 'Manufacturing' },
        { value: 'Marketing & Advertising', label: 'Marketing & Advertising' },

        { value: 'Media', label: 'Media' },
        { value: 'Nonprofit', label: 'Nonprofit' },
        { value: 'Pharmaceuticals', label: 'Pharmaceuticals' },
        { value: 'Real Estate', label: 'Real Estate' },
        { value: 'Retail', label: 'Retail' },
        { value: 'Telecommunications', label: 'Telecommunications' },

        { value: 'Transportation', label: 'Transportation' },
        { value: 'Travel & Tourism', label: 'Travel & Tourism' },
        { value: 'Utilities', label: 'Utilities' },
        { value: 'Other', label: 'Other' },
    ];

    useEffect(() => {
        handleCity();
        handlePlans();
        return () => {
            if (file && file.preview) {
                URL.revokeObjectURL(file.preview);
            }
        };
    }, [file]);

    useEffect(() => {
        handleCity(searchQuery);
    }, [searchQuery]);

    const handleInputChange = (event, { action }) => {
        const searchTerm = event;
        // Fetch cities only when the search query length is greater than or equal to 3 characters
        if (searchTerm?.length >= 3) {
            setSearchQuery(searchTerm);
        }
    };

    const handleCity = (searchQuery) => {
        setIsFetchingCities(true);
        const token = apiService.getAuthToken();
        apiService.get(`get-cities?city=${searchQuery || ''}`, token)
            .then((response) => {
                const transformedCities = response.data.map(city => ({
                    label: city.name,
                    value: city.name,
                    state: city.state_name
                }));
                setCitiesList(transformedCities);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setIsFetchingCities(false);
            })
    }

    const handlePlans = () => {
        setIsFetchingPlans(true);
        const token = apiService.getAuthToken();
        apiService.get('get-organization-plans', token)
            .then((response) => {
                const transformedPlans = response.data.map(plan => ({
                    label: plan.planName,
                    value: plan.planId,
                    details: plan
                }));
                setPlansList(transformedPlans);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setIsFetchingPlans(false);
            })
    }

    const handleCityChange = (selectedOption) => {
        setSelectedShowCity(selectedOption)
        setSelectedCity(selectedOption.value);
        setSelectedState(selectedOption.state);
    };

    const handlePlanChange = (selectedOption) => {
        setSelectedShowPlan(selectedOption);
        setSelectedPlan(selectedOption.value);
    };

    const handleOrgSizeChange = (value) => {
        setSelectedOrgSize(value);
    }

    const handleSectorChange = (value) => {
        setSelectedSector(value);
    }

    const handleAddEntity = () => {
        if (entityInput.trim() !== '') {
            setEntities([...entities, entityInput.trim()]);
            setEntityInput('');
        }
    };

    const handleEntityKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddEntity();
        }
    };

    const handleRemoveEntity = (index) => {
        const newEntities = [...entities];
        newEntities.splice(index, 1);
        setEntities(newEntities);
    };

    const handleAddBranch = () => {
        if (branchInput.trim() !== '') {
            setBranches([...branches, branchInput.trim()]);
            setBranchInput('');
        }
    };

    const handleBranchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddBranch();
        }
    };

    const handleRemoveBranch = (index) => {
        const newBranches = [...branches];
        newBranches.splice(index, 1);
        setBranches(newBranches);
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setContactEmail(newEmail);
        validateEmail(newEmail);
    };

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailPattern.test(email);
        if (!isValid) {
            setEmailError('Please enter a valid email address.');
        } else {
            setEmailError('');
        }
    };

    const handlePhoneChange = (e) => {
        const newPhoneNumber = e.target.value;
        setContactMobile(newPhoneNumber);
        validatePhone(newPhoneNumber);
    };

    const validatePhone = (phone) => {
        const phonePattern = /^[0-9]{10}$/;
        const isValid = phonePattern.test(phone);
        if (!isValid) {
            setPhoneError('Please enter a valid 10-digit phone number.');
        } else {
            setPhoneError('');
        }
    };

    const handleImageChange = (e) => {

        setSelectedFile(e.target.files[0]);
        const selectedImage = e.target.files[0];
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml'];

        if (selectedImage && allowedTypes.includes(selectedImage.type)) {
            setFile({ preview: URL.createObjectURL(selectedImage) });
        } else {
            CustomToast.error('Please select a PNG, JPG, SVG or JPEG file.');
        }

    };

    const handleCertificateImageChange = (e) => {

        setSelectedCertificateFile(e.target.files[0]);
        const selectedCertificateImage = e.target.files[0];
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml'];

        if (selectedCertificateImage && allowedTypes.includes(selectedCertificateImage.type)) {
            setCertificateFile({ preview: URL.createObjectURL(selectedCertificateImage) });
        } else {
            CustomToast.error('Please select a PNG, JPG, SVG or JPEG file.');
        }

    };

    // const handleFileChange = (event) => {

    // };

    const handleSend = (event) => {
        event.preventDefault();
        setLoader(true)
        const formData = new FormData();
        formData.append("org_name", org_name);
        formData.append("org_size", selectedOrgSize);
        formData.append("org_sector", selectedSector);
        formData.append("org_url", org_url);
        formData.append("org_address", org_address);
        formData.append("org_city", selectedCity);
        formData.append("org_state", selectedState);
        formData.append("org_pincode", org_pincode);
        formData.append("plan_id", selectedPlan);
        formData.append("contact_name", contact_name);
        formData.append("contact_email", contact_email);
        formData.append("contact_mobile", contact_mobile);
        formData.append("contact_designation", contact_designation);
        formData.append("contract_start_date", contract_start_date);
        formData.append("contract_end_date", contract_end_date);
        if (selectedFile) {
            formData.append("image", selectedFile, selectedFile.name);
        }
        if (selectedCertificateFile) {
            formData.append("org_logo", selectedCertificateFile, selectedCertificateFile.name);
        }
        // const commaSeparatedValues = entities.map(item => item).join(',');
        if (entities && entities.length > 0) {
            const commaSeparatedValues = entities?.join(",")
            formData.append("entities", commaSeparatedValues);
        }
        if (branches && branches.length > 0) {
            const commaSeparatedBranches = branches?.join(",")
            formData.append("branches", commaSeparatedBranches);
        }

        const token = apiService.getAuthToken()
        apiService.postFormdata('create-org', formData, token)
            .then((response) => {
                setOrgName('');
                setSelectedOrgSize('');
                setSelectedSector('');
                setOrgUrl('');
                setEntities([]);
                setEntityInput('');
                setBranches([]);
                setBranchInput('');
                setOrgAddress('');
                setSelectedCity('');
                setSelectedShowCity('');
                setSelectedState('');
                setOrgPincode('');
                setSelectedPlan('');
                setSelectedShowPlan('');
                setContactName('');
                setContactEmail('');
                setContactMobile('');
                setContactDesignation('');
                setSelectedFile(null);
                setContactStartDate('');
                setContactEndDate('');
                setFile(null);
                setSelectedCertificateFile(null);
                setCertificateFile(null);
                setLoader(false)
                CustomToast.success('Organization was created successfully.')
                navigate(`/organisation`);
            })
            .catch((e) => {
                setLoader(false)
                CustomToast.error(e.message);
            });
    }

    const handleClose = () => {
        navigate(`/organisation`);
        window.scrollTo(0, 0);
    };

    const handleNext = () => {
        if (step === 1) {
            if (!org_name || !selectedOrgSize || !selectedSector || !org_url) {
                CustomToast.error("Please fill all required fields in Basic Information.");
                return;
            }
        } else if (step === 2) {
            if (!org_address || !selectedCity || !selectedState || !org_pincode) {
                CustomToast.error("Please fill all required fields in Address Information.");
                return;
            }
        } else if (step === 3) {
            if (!contact_name || !contact_email || !contact_mobile || !contact_designation) {
                CustomToast.error("Please fill all required fields in Contact Information.");
                return;
            }
        } else if (step === 4) {
            if (!contract_start_date || !contract_end_date) {
                CustomToast.error("Please fill all required fields in Contract Information.");
                return;
            }
        }
        setStep(step + 1);
    }

    return (
        <>
            <div className='page__main'>
                <div className="dashboard" style={{ minHeight: '100vh' }}>
                    <div className='profile-form-wrapper w-100'>
                        <h3 className='font-weight-600 font-20 mb-4'>Create Organisation</h3>

                        {loader ? <Loader /> :
                            <form onSubmit={handleSend} className="needs-validation" noValidate>
                                {/* Stepper Progress Bar */}
                                <div className="card p-0 mb-4">
                                    <div className="card-body pb-0 px-3">
                                        <div className="d-flex justify-content-between align-items-center stepper">
                                            {[
                                                { number: 1, label: "Basic Information" },
                                                { number: 2, label: "Organisation Address" },
                                                { number: 3, label: "Primary Contact" },
                                                // { number: 4, label: "Customisation" },
                                                { number: 4, label: "Organisation Plan" },
                                            ].map((item, idx) => {
                                                const isCompleted = step > item.number;
                                                const isActive = step === item.number;

                                                return (
                                                    <div key={idx} className={`d-flex align-items-center flex-fill pb-3 ${isCompleted ? "step-completed" : isActive ? "step-active" : ""
                                                                    }`}>
                                                        {/* Circle + Text */}
                                                        <div className={`d-flex align-items-center flex-row`}>
                                                            <div
                                                                className={`step-circle mx-auto mb-2 me-2 ${isCompleted ? "completed" : isActive ? "active" : ""
                                                                    }`}
                                                            >
                                                                {isCompleted ? (
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                                                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                                                    </svg> // Bootstrap Icons checkmark
                                                                ) : (
                                                                    item.number
                                                                )}
                                                            </div>
                                                            <div>
                                                                <div className="fw-bold">{item.label}</div>
                                                                <div className="text-muted small">Step-{item.number}</div>
                                                            </div>
                                                        </div>

                                                        {/* Line between steps */}
                                                        {idx < 3 && <div className="step-line flex-grow-1"></div>}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex flex-row justify-content-between gap-4 mb-3 mx-0'>
                                    <div className="card col-9 p-lg-3 p-0">
                                        <div className="card-body d-flex justify-content-between flex-column">
                                            {/* Step 1 – Basic Information */}
                                            {step === 1 && (<>
                                                <div className='d-flex justify-content-between flex-column'>
                                                    <h5 className="fw-bold mb-4 primary_color">Basic Information</h5>
                                                    <div className="row g-3">
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Org. Name*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={org_name}
                                                                onChange={(e) => setOrgName(e.target.value)}
                                                                required
                                                            />
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <label className="form-label">Org. Size*</label>
                                                            <CustomSelect
                                                                id="orgSizeSelect"
                                                                name="selectedOrgSize"
                                                                placeholder="Select"
                                                                value={selectedOrgSize}
                                                                options={orgSizeOptions}
                                                                onChange={handleOrgSizeChange}>
                                                            </CustomSelect>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <label className="form-label">Sector / Industry*</label>
                                                            <CustomSelect
                                                                id="sectorSelect"
                                                                name="selectedSector"
                                                                placeholder="Select"
                                                                value={selectedSector}
                                                                options={sectorOptions}
                                                                onChange={handleSectorChange}>
                                                            </CustomSelect>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <label className="form-label">Org. Website*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={org_url}
                                                                onChange={(e) => setOrgUrl(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between border-top mt-4'>
                                            <button type="button" className="btn btn-white border px-4 py-2 mt-4 rounded-pill" onClick={handleClose}>
                                                Cancel
                                            </button>
                                            <button type="button" className="btn btn-primary px-4 py-2 mt-4 rounded-pill" onClick={handleNext}>
                                                Next <img src="/images/arrow_right.svg" alt="Next" className='ms-2' />
                                            </button>
                                        </div>
                                            </>
                                            )}

                                            {/* Step 2 – Address & Plan */}
                                            {step === 2 && (
                                                <div className='d-flex justify-content-between flex-column'>
                                                    <h5 className="fw-bold primary_color font-20 mb-4">Organisation Address</h5>
                                                    <div className="row g-3">
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Org. Address*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={org_address}
                                                                onChange={(e) => setOrgAddress(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">City*</label>
                                                            <Select
                                                                options={citiesList}
                                                                value={selectedShowCity}
                                                                onInputChange={handleInputChange}
                                                                isLoading={isFetchingCities}
                                                                onChange={handleCityChange}
                                                            />
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">State*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={selectedState}
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Postal Code*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={org_pincode}
                                                                onChange={(e) => setOrgPincode(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <h5 className="fw-bold form-label font-16 mt-4 mb-0">Entities</h5>
                                                        <div className="input-group mb-3">
                                                            <input
                                                                type="text"
                                                                className="form-control me-2"
                                                                placeholder="Add entity"
                                                                value={entityInput}
                                                                onChange={(e) => setEntityInput(e.target.value)}
                                                                onKeyPress={handleEntityKeyPress}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={handleAddEntity}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>
                                                        <div>
                                                            {entities.map((entity, idx) => (
                                                                <span
                                                                    key={idx}
                                                                    className="badge btn-primary me-2 mb-2 d-inline-flex align-items-center"
                                                                >
                                                                    {entity}
                                                                    <button
                                                                        type="button"
                                                                        className="btn-close btn-close-white ms-2"
                                                                        onClick={() => handleRemoveEntity(idx)}
                                                                    />
                                                                </span>
                                                            ))}
                                                        </div>

                                                        <h5 className="fw-bold form-label font-16 mt-4 mb-0">Branches</h5>
                                                        <div className="input-group mb-3">
                                                            <input
                                                                type="text"
                                                                className="form-control me-2"
                                                                placeholder="Add branch"
                                                                value={branchInput}
                                                                onChange={(e) => setBranchInput(e.target.value)}
                                                                onKeyPress={handleBranchKeyPress}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={handleAddBranch}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>
                                                        <div>
                                                            {branches.map((branch, idx) => (
                                                                <span
                                                                    key={idx}
                                                                    className="badge btn-primary me-2 mb-2 d-inline-flex align-items-center"
                                                                >
                                                                    {branch}
                                                                    <button
                                                                        type="button"
                                                                        className="btn-close btn-close-white ms-2"
                                                                        onClick={() => handleRemoveBranch(idx)}
                                                                    />
                                                                </span>
                                                            ))}
                                                        </div>

                                                    </div>

                                                    <div className="d-flex justify-content-between border-top mt-5">
                                                        <button
                                                            type="button"
                                                            className="btn btn-white border px-4 py-2 mt-4 rounded-pill d-flex align-items-center"
                                                            onClick={() => setStep(step - 1)}
                                                        >
                                                            <img src="/images/arrow_left.svg" alt="Back" className='me-2' /> Back
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary px-4 py-2 mt-4 rounded-pill d-flex align-items-center"
                                                            onClick={handleNext}
                                                        >
                                                            Next <img src="/images/arrow_right.svg" alt="Next" className='ms-2' />
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Step 3 – Primary Contact */}
                                            {step === 3 && (
                                                <div className='d-flex justify-content-between flex-column'>
                                                    <h5 className="fw-bold primary_color font-20 mb-4">Primary Contact</h5>
                                                    <div className="row g-3">
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Name*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={contact_name}
                                                                onChange={(e) => setContactName(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Email*</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                value={contact_email}
                                                                onChange={handleEmailChange}
                                                                required
                                                            />
                                                            {emailError && <div className="text-danger">{emailError}</div>}
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Mobile*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={contact_mobile}
                                                                onChange={handlePhoneChange}
                                                                required
                                                            />
                                                            {phoneError && <div className="text-danger">{phoneError}</div>}
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Designation*</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={contact_designation}
                                                                onChange={(e) => setContactDesignation(e.target.value)}
                                                                required
                                                            />
                                                        </div>

                                                    </div>

                                                    <div className="d-flex justify-content-between border-top mt-5">
                                                        <button
                                                            type="button"
                                                            className="btn btn-white border px-4 py-2 mt-4 rounded-pill d-flex align-items-center"
                                                            onClick={() => setStep(step - 1)}
                                                        >
                                                            <img src="/images/arrow_left.svg" alt="Back" className='me-2' /> Back
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary px-4 py-2 mt-4 rounded-pill d-flex align-items-center"
                                                            onClick={handleNext}
                                                        >
                                                            Next <img src="/images/arrow_right.svg" alt="Next" className='ms-2' />
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {/* // Step 4 – Customisation Plan
                                            {step === 4 && (
                                                <div>
                                                    <h5 className="fw-bold primary_color font-20">Customisation</h5>
                                                    <div className="mb-4 text-center">
                                                        <div
                                                            className="border rounded p-3 d-inline-block"
                                                            style={{ maxWidth: "200px" }}
                                                        >
                                                            {certificateFile && (
                                                                <img
                                                                    src={certificateFile.preview}
                                                                    alt="Preview"
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "200px", objectFit: "contain" }}
                                                                />
                                                            )}
                                                        </div>
                                                        <div className="mt-3">
                                                            <label className="btn btn-outline-primary">
                                                                Change Image
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    hidden
                                                                    onChange={handleCertificateImageChange}
                                                                />
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex justify-content-between mt-5">
                                                        <button
                                                            type="button"
                                                            className="btn btn-white border px-4 py-2 mt-4 rounded-pill d-flex align-items-center"
                                                            onClick={() => setStep(step - 1)}
                                                        >
                                                            ← Back
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary px-4 py-2 rounded-pill"
                                                            onClick={handleNext}
                                                        >
                                                            Next →
                                                        </button>
                                                    </div>
                                                </div>
                                            )} */}

                                            {/* Step 4 – Organization Plan */}
                                            {step === 4 && (
                                                <div className='d-flex justify-content-between flex-column'>
                                                    <h5 className="fw-bold primary_color font-20">Organization Plan</h5>
                                                    <div className='row'>
                                                        <div className="col-lg-12 px-0">

                                                            {isFetchingPlans ? (
                                                                <div className="d-flex justify-content-center">
                                                                    <div className="spinner-border text-primary" role="status">
                                                                        <span className="visually-hidden">Loading...</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="plan-switches-container">
                                                                    <div className="row g-3">
                                                                        {plansList.map((plan, index) => (
                                                                            <div key={plan.value} className="col-lg-6 col-md-6 col-12">
                                                                                <div className="form-check form-switch plan-switch-item">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        name="organizationPlan"
                                                                                        id={`plan-${plan.value}`}
                                                                                        checked={selectedShowPlan?.value === plan.value}
                                                                                        onChange={() => handlePlanChange(plan)}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor={`plan-${plan.value}`}>
                                                                                        <div className="plan-info">
                                                                                            <span className="plan-name">{plan.label}</span>
                                                                                        </div>
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <h5 className="fw-bold primary_color font-20 mt-4">Contract Date</h5>
                                                    <div className='row mt-3'>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Contract Start Date</label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={contract_start_date}
                                                                onChange={(e) => setContactStartDate(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">Contract End Date</label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={contract_end_date}
                                                                onChange={(e) => setContactEndDate(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="d-flex justify-content-between border-top">
                                                        <button
                                                            type="button"
                                                            className="btn btn-white border px-4 py-2 mt-4 rounded-pill d-flex align-items-center"
                                                            onClick={() => setStep(step - 1)}
                                                        >
                                                            <img src="/images/arrow_left.svg" alt="Back" className='me-2' /> Back
                                                        </button>
                                                        <button type="submit" className="btn btn-primary px-4 py-2 mt-4 rounded-pill d-flex align-items-center">
                                                            Create <img src="/images/arrow_right.svg" alt="Next" className='ms-2' />
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col p-0">
                                        <div className="card mb-4">
                                            {/* Step 5 – Certificate Logo Upload */}
                                            {/* {step === 1 && ( */}
                                            <div className='card-body text-center'>
                                                <h5 className="fw-bold primary_color font-20 mx-auto">Organisation Logo</h5>
                                                <div className="form-group w-100 fw-regular mt-4">
                                                    <label className='custom-image-upload org flex-column w-100 rounded-4' style={{ cursor: 'pointer' }}>
                                                        <input
                                                            type="file"
                                                            name="file"
                                                            accept="image/*"
                                                            onChange={handleImageChange}
                                                            style={{ display: 'none' }}
                                                            id="imageUploadInput"
                                                        />

                                                        <div className='m-auto' style={{ maxHeight: '200px', maxWidth: '200px' }}>
                                                            {file ? (
                                                                <img
                                                                    src={file.preview}
                                                                    className='w-100'
                                                                    style={{ maxHeight: '200px', maxWidth: '200px', objectFit: 'contain' }}
                                                                    alt="Uploaded preview"
                                                                />
                                                            ) : (
                                                                <>
                                                                    <img src="/images/image-icon.svg" alt="camera icon" style={{ width: "50px", height: "50px" }} />
                                                                    <p className='small fw-regular mt-2'>
                                                                        Supported formats include JPG, PNG<br /> Max file size: 10MB.
                                                                    </p>
                                                                </>
                                                            )}
                                                        </div>

                                                        {file && (
                                                            <div className='mt-auto align-self-end'>
                                                                <img src="/images/add_org_logo.svg" alt="add logo" style={{ width: "40px", height: "40px", position: "absolute", right: 0, top: "auto", bottom: 0 }} />
                                                            </div>
                                                        )}
                                                    </label>

                                                </div>
                                            </div>
                                            {/* )} */}
                                        </div>
                                        <div className="card">
                                            {/* Step 5 – Certificate Logo Upload */}
                                            {/* {step === 1 && ( */}
                                            <div className='card-body text-center'>
                                                <h5 className="fw-bold primary_color font-20 mx-auto">Certificate Logo Upload</h5>
                                                {/* <div className="form-group w-100 mt-4">
                                                        <label className='custom-image-upload org w-100 rounded-4'>
                                                            <div className='m-auto' style={{ maxHeight: '200px', maxWidth: '200px' }}>
                                                                <img src={certificateFile && certificateFile.preview} className='w-100' style={{ maxHeight: '200px', maxWidth: '200px', objectFit: 'contain' }} />
                                                            </div>
                                                        </label>

                                                        <p className='small mx-auto mt-2'>Drag and drop an image here, or click to browse your files. Supported formats include JPG, PNG Max file size: 10MB.</p>
                                                        <a className='img_upload fw-bold position-relative bottom-0 mx-auto'>Change Image
                                                            <input
                                                                accept="image/*"
                                                                name="certificateFile"
                                                                type="file"
                                                                onChange={handleCertificateImageChange}
                                                                style={{ display: 'none' }}
                                                            />
                                                        </a>
                                                    </div> */}
                                                <div className="form-group w-100 mt-4">
                                                    <label className="custom-image-upload org w-100 rounded-4" style={{ cursor: 'pointer' }}>
                                                     {certificateFile && <div className="m-auto">
                                                            <img
                                                                src={certificateFile && certificateFile.preview}
                                                                className="w-100"
                                                                // style={{ maxHeight: '200px', maxWidth: '200px', objectFit: 'contain' }}
                                                                alt="Certificate Preview"
                                                            />
                                                        </div> }

                                                        {/* Hidden input inside the label */}
                                                        <input
                                                            accept="image/*"
                                                            name="certificateFile"
                                                            type="file"
                                                            onChange={handleCertificateImageChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                    </label>

                                                    <p className="small mx-auto mt-2">
                                                        Drag and drop an image here, or click to browse your files.
                                                        Supported formats: JPG, PNG. Max file size: 10MB.
                                                    </p>

                                                    {/* Optional: This can stay or be removed since the label now handles the click */}
                                                    <a className="img_upload fw-bold position-relative bottom-0 mx-auto" onClick={() => document.querySelector('input[name="certificateFile"]').click()} style={{ cursor: 'pointer' }}>
                                                        Change Image
                                                    </a>
                                                </div>

                                            </div>
                                            {/* )} */}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                </div>
            </div>

            <style jsx>{`
                .plan-switches-container {
                    margin-top: 12px;
                }

                .plan-switches-container .row {
                    margin: 0;
                }

                .plan-switches-container .col-lg-6,
                .plan-switches-container .col-md-6,
                .plan-switches-container .col-12 {
                    padding: 0 8px;
                }

                .plan-switch-item {
                     border: 1px solid #212529;
                     border-radius: 4px;
                     padding: 10px 10px 10px 20px;
                     transition: all 0.3s ease;
                     background-color: #ffffff;
                     cursor: pointer;
                     display: flex;
                     align-items: center;
                     flex-direction: row-reverse;
                     gap: 12px;
                     height: 100%;
                     width: 100%;
                }

               .plan-switch-item input[type="radio"]:after {
                  display: none;
                }

                .plan-switch-item .form-check-input {
                    width: 20px;
                    height: 20px;
                    margin-top: 2px;
                    cursor: pointer;
                    border: 2px solid #dee2e6;
                }

                .plan-switch-item .form-check-input:checked {
                    background-color: #2e8366ff;
                    border-color: #2e8366ff;
                }

                .plan-switch-item .form-check-label {
                    cursor: pointer;
                    flex: 1;
                    margin-bottom: 0;
                }

                .plan-info {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                .plan-name {
                    font-weight: 500;
                    font-size: 15px;
                    color: #212529;
                    line-height: 1.4;
                }

                @media (max-width: 768px) {
                    .plan-switches-container .col-lg-6,
                    .plan-switches-container .col-md-6 {
                        margin-bottom: 16px;
                    }

                    .plan-switches-container .col-lg-6,
                    .plan-switches-container .col-md-6,
                    .plan-switches-container .col-12 {
                        padding: 0 4px;
                    }

                    .plan-switch-item {
                        padding: 12px;
                    }

                    .plan-name {
                        font-size: 15px;
                    }

                    .plan-info small {
                        font-size: 13px;
                    }
                }

                @media (max-width: 576px) {
                    .plan-switches-container .row .col-lg-6,
                    .plan-switches-container .row .col-md-6 {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }
            `}</style>
        </>
    )
}

export default CreateOrgnisation;